export default {"src":"/_next/static/media/reward.61af5108.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};